<template>
  <div class="home">
    <div class="view bg-pink" v-if="currentView == 1">
      <div class="container full centered">
          <div class="holder-content row">
            <div class="wrapper col-sm-12 col-md-6">
              <div class="view-title">
                <h1 class="header1">Ontdek binnen 2 minuten welk internetpakket het best bij je bedrijf past</h1>
              </div>
              <p>Geen één onderneming is hetzelfde. Daarom helpt T-Mobile Ondernemen je graag verder. Doe de keuzetest en ontdek welk pakket voor Zakelijk Internet past bij het internetgebruik van jouw bedrijf.*</p>
              <div class="media-container" v-if="mobileView"><div class="media"><img :src="require('@/assets/img/home-image.png')"/></div></div>
              <Button size="desktop-inline" class="landing-button" type="secondary" label="AAN DE SLAG" @click.native="nextPage"/>
              <div class="text-caption">*Het advies kan op basis van de ingevulde postcode verschillen. Doe na de keuzetest de postcodecheck om te ontdekken welke internetverbindingen er mogelijk zijn op jouw bedrijfsadres.</div>
            </div>
            <div class="wrapper col-md-6 align-self-center" v-if="!mobileView">
              <div class="media-container my-auto">
                <div class="media">
                  <img :src="require('@/assets/img/home-image.png')"/>
                </div>
              </div>
            </div>
          </div>
      </div>
    </div> 
    <div class="view" v-if="currentView == 2">
      <div class="container">
        <div class="view-title">
          <h2 class="header2">Heb je een koper- of glasvezelverbinding op je locatie?</h2>
        </div>
        <div class="holder-buttons">
          <div class="row">
            <div class="btn-wrapper col-12 col-md-4">
              <Question label="Koper" value="koper|basic,compleet" name="question1" v-model="firstQuestion" />
            </div>
            <div class="btn-wrapper col-12 col-md-4">
              <Question label="Glasvezel" value="glasvezel|basic,compleet,extra" name="question1" v-model="firstQuestion" />
            </div>
            <div class="btn-wrapper col-12 col-md-4">
              <Question label="Weet ik niet" value="noidea|basic,compleet,extra,diff" name="question1" v-model="firstQuestion" />
            </div>
          </div>
        </div>
      </div>
      <div class="question-navigation">
        <div class="indicator">
          <div class="bar">
            <div class="fill" style="width: 20%"></div>
          </div>
        </div>
        <div class="container p-0">
          <div class="button-set">
            <Button type="primary" label="Ga verder" class="desktop-inline" :class="firstApproved ? '' : 'disabled'"  @click.native="nextPage"/>
          </div>
        </div>
      </div>
    </div>

    <div class="view" v-if="currentView == 3">
      <div class="container">
        <div class="view-title">
          <h2 class="header2">Wie gebruikt er internet binnen jouw bedrijf? </h2>
          <p>Meerdere antwoorden zijn mogelijk</p>
        </div>
        <div class="holder-buttons">
          <div class="row">
            <div class="btn-wrapper col-12 col-md-6">
              <QuestionSelect label="Medewerkers" value="basic,compleet,extra" name="question-select" v-model="secondQuestion[0].setting"/>
            </div>
            <div class="btn-wrapper col-12 col-md-6">
              <QuestionSelect label="Bewoners" value="basic,compleet,extra" name="question-select2" v-model="secondQuestion[1].setting" />
            </div>
            <div class="btn-wrapper col-12 col-md-6">
              <QuestionSelect label="Gasten" value="compleet,extra" name="question-select3" v-model="secondQuestion[2].setting" />
            </div>
            <div class="btn-wrapper col-12 col-md-6">
              <QuestionSelect label="Klanten" value="compleet,extra" name="question-select3" v-model="secondQuestion[3].setting" />
            </div>
          </div>
        </div>
      </div>
      <div class="question-navigation">
        <div class="indicator">
          <div class="bar">
            <div class="fill" style="width: 40%"></div>
          </div>
        </div>
        <div class="container p-0">
          <div class="button-set">
            <Button type="tertiary" label="Terug" class="mobile-small" @click.native="currentView--"/>
            <Button type="primary" label="Ga verder" class="mobile-big"  :class="secondApproved ? '' : 'disabled'" @click.native="nextPage"/>
          </div>
        </div>
      </div>
    </div>
    <div class="view" v-if="currentView == 4">
      <div class="container">
        <div class="view-title">
          <h2 class="header2">Is er een continu gebruik van meer of minder dan 20 medewerkers/applicaties?</h2>
        </div>
        <div class="holder-buttons">
          <div class="row">
            <div class="btn-wrapper col-12 col-md-6">
              <Question label="Meer dan 20" value="maat" name="question1" v-model="thirdQuestion" />
            </div>
            <div class="btn-wrapper col-12 col-md-6">
              <Question label="Minder dan 20" value="basic,compleet,extra" name="question1" v-model="thirdQuestion" />
            </div>
          </div>
        </div>
      </div>
      <div class="question-navigation">
        <div class="indicator">
          <div class="bar">
            <div class="fill" style="width: 60%"></div>
          </div>
        </div>
        <div class="container p-0">
          <div class="button-set">
            <Button type="tertiary" label="Terug" class="mobile-small" @click.native="currentView--"/>
            <Button type="primary" label="Ga verder" class="mobile-big"  :class="thirdApproved ? '' : 'disabled'" @click.native="nextPage"/>
          </div>
        </div>
      </div>
    </div>
    <div class="view" v-if="currentView == 5">
      <div class="container">
        <div class="view-title">
          <h2 class="header2">Waar gebruiken jullie het internet in jouw bedrijf vooral voor? </h2>
          <p>Meerdere antwoorden zijn mogelijk</p>
        </div>
        <div class="holder-buttons">
          <div class="row">
            <div class="btn-wrapper col-12 col-md-6">
              <QuestionSelect label="Internet en/of e-mail" value="basic" name="question-select" v-model="fourthQuestion[0].setting"/>
            </div>
            <div class="btn-wrapper col-12 col-md-6">
              <QuestionSelect label="Cloudservices" value="extra" name="question-select2" v-model="fourthQuestion[1].setting" />
            </div>
            <div class="btn-wrapper col-12 col-md-6">
              <QuestionSelect label="Videobellen" value="compleet" name="question-select3" v-model="fourthQuestion[2].setting" />
            </div>
            <div class="btn-wrapper col-12 col-md-6">
              <QuestionSelect label="Downloaden" value="compleet" name="question-select3" v-model="fourthQuestion[3].setting" />
            </div>
            <div class="btn-wrapper col-12 col-md-6">
              <QuestionSelect label="Toegang tot het internet van buitenaf (VPN, beveiligingsapparatuur)" class="force-small" value="compleet" name="question-select3" v-model="fourthQuestion[4].setting" :style="{fontSize: '14px'}" />
            </div>
            <div class="btn-wrapper col-12 col-md-6">
              <QuestionSelect label="Pintransacties" value="extra" name="question-select3" v-model="fourthQuestion[5].setting" />
            </div>
            <div class="btn-wrapper col-12 ">
              <QuestionSelect label="Geen van bovenstaande" value="maat" name="question-select3" v-model="fourthQuestion[6].setting" />
            </div>
          </div>
        </div>
      </div>
      <div class="question-navigation">
        <div class="indicator">
          <div class="bar">
            <div class="fill" style="width: 80%"></div>
          </div>
        </div>
        <div class="container p-0">
          <div class="button-set">
            <Button type="tertiary" label="Terug" class="mobile-small" @click.native="currentView--"/>
            <Button type="primary" label="Ga verder" class="mobile-big"  :class="fourthApproved ? '' : 'disabled'" @click.native="nextPage"/>
          </div>
        </div>
      </div>
    </div>
    <div class="view bg-pink" v-if="currentView == 6">
      <div class="container full full-centered">
          <div class="holder-content ">
            <div class="loader"></div>
            <h3 class="header3">Even geduld</h3>
            <p class="text-white text-center">We zijn een advies aan het samenstellen op basis van je antwoorden.</p>
          </div>
      </div>
    </div> 

    <div class="view result" v-if="currentView == 7">
      <div class="container">
        <div class="restart" :style="{display: 'flex', alignItems: 'center', marginRight: '16px'}"  @click="restartPage()"><div class="icon-item" :style="{position: 'relative', top: '-2px'}"><inline-svg width="20" height="20" class="indicator" :src="require(`@/assets/img/next.svg`)" fill="var(--blue-dark)" :style="{transform: 'rotate(180deg)'}" alt="result-icon"/></div>Terug naar het begin</div>
        <div class="row">
          <div class="col-12 col-md-8">
            <div class="result-item">
              <div class="top-bar">
                <h4 class="header4">Meest geschikt</h4>
                <!-- <div class="restart" @click="location.reload()">Opnieuw</div> -->
              </div>
              <div class="holder">
                <div class="icon">
                  <inline-svg class="indicator" :src="require(`@/assets/img/icon-high.svg`)"  alt="result-icon"/>
                </div>
                <div class="details">
                  <div class="pack-wrapper">
                    <h3 class="header3 pack-name">{{this.result.name}}</h3>
                    <div class="total-detail">
                      <p class="pack-detail">{{answerLabel === 'koper' ? '' : this.result.detail }}</p>
                      <p class="pack-price"><b>€ {{this.result.price}}</b>/mnd</p>
                    </div>
                    
                    <p class="pack-discount">{{this.result.discount}}</p>
                    
                  </div>
                  <div class="disclaimer">
                    <div class="icon-disclaimer">
                      <inline-svg width="20" height="20" class="indicator" :src="require(`@/assets/img/error.svg`)" fill="var(--blue)"  alt="result-icon"/>
                    </div>
                    <p class="small">Let op: dit is een algemeen advies op basis van je antwoorden. Doe de postcodecheck om te zien welke pakketten wij kunnen leveren op jouw locatie of neem contact met ons op. </p>
                  </div>
                  <p class="description">{{this.result.description}}</p>
                  <div class="pack-list">
                    <p class="title">Inclusief</p>
                    <div class="list-item" v-for="listItem in this.result.list" :key="listItem">
                      <div class="icon-item"><inline-svg width="20" height="20" class="indicator" :src="require(`@/assets/img/check.svg`)" fill="var(--green)"  alt="result-icon"/></div>
                      <div class="item" v-html="listItem"></div>
                    </div>
                  </div>
                </div>
              </div>
              
            </div>

            <div class="extra-panels">
                <h3 class="header3">Wat bieden wij nog meer?</h3>
                <div class="holder-options" v-if="mobileView">
                  <VueSlickCarousel v-bind="slickSettings">
                    <div class="option-wrapper">
                      <div class="option">
                        <div class="icon-option">
                          <inline-svg width="42" height="42" class="indicator" :src="require(`@/assets/img/vast-ip.svg`)"  alt="result-icon"/>
                        </div>
                        <div class="detail-option">
                          <p class="intro">Vast IP-adres</p>
                          <p class="description">Gegarandeerd toegang tot je bedrijfsnetwerk. Veilig, stabiel en betrouwbaar.</p>
                          <a target="_blank" href="https://www.t-mobile.nl/zakelijk/internet?utm_source=keuzehulpzi&utm_medium=referral&utm_campaign=_zakelijk_map_tell_soho_fixed&utm_content=landingpagina_keuzehulp_zi_vast_ip#se4">Wat heb je aan een vast IP-adres?</a>
                        </div>
                      </div>
                    </div>
                    <div class="option-wrapper">
                      <div class="option">
                        <div class="icon-option">
                          <inline-svg width="42" height="42" class="indicator" :src="require(`@/assets/img/wifiplus.svg`)"  alt="result-icon"/>
                        </div>
                        <div class="detail-option">
                          <p class="intro">Wifi Plus</p>
                          <p class="description">Versterk en verbeter je wifi-netwerk met meerdere zelflerende wifi-punten die strategisch op de zaak geplaatst worden.</p>
                          <a target="_blank" href="https://www.t-mobile.nl/zakelijk/internet/wifi-plus">Hoe werkt Wifi Plus?</a>
                        </div>
                      </div>
                    </div>
                    <div class="option-wrapper">
                      <div class="option">
                        <div class="icon-option">
                          <inline-svg width="42" height="42" class="indicator" :src="require(`@/assets/img/pin-veilig.svg`)"  alt="result-icon"/>
                        </div>
                        <div class="detail-option">
                          <p class="intro">PIN veilig</p>
                          <p class="description">Een betrouwbare pinverbinding voor je zaak. Zo kunnen je klanten zorgeloos pinnen, zelfs met topdrukte.</p>
                          <a target="_blank" href="https://www.t-mobile.nl/zakelijk/internet/pin-veilig?utm_source=keuzehulpzi&utm_medium=referral&utm_campaign=_zakelijk_map_tell_soho_fixed&utm_content=landingpagina_keuzehulp_zi_pinveilig">Hoe werkt PIN veilig?</a>
                        </div>
                      </div>
                    </div>
                  </VueSlickCarousel>
                </div>
                <div class="holder-options" v-else>
                  <div class="option-wrapper">
                      <div class="option">
                        <div class="icon-option">
                          <inline-svg width="42" height="42" class="indicator" :src="require(`@/assets/img/vast-ip.svg`)"  alt="result-icon"/>
                        </div>
                        <div class="detail-option">
                          <p class="intro">Vast IP-adres</p>
                          <p class="description">Gegarandeerd toegang tot je bedrijfsnetwerk. Veilig, stabiel en betrouwbaar.</p>
                          <a target="_blank" href="https://www.t-mobile.nl/zakelijk/internet?utm_source=keuzehulpzi&utm_medium=referral&utm_campaign=_zakelijk_map_tell_soho_fixed&utm_content=landingpagina_keuzehulp_zi_vast_ip#se4">Wat heb je aan een vast IP-adres?</a>
                        </div>
                      </div>
                    </div>
                    <div class="option-wrapper">
                      <div class="option">
                        <div class="icon-option">
                          <inline-svg width="42" height="42" class="indicator" :src="require(`@/assets/img/wifiplus.svg`)"  alt="result-icon"/>
                        </div>
                        <div class="detail-option">
                          <p class="intro">Wifi Plus</p>
                          <p class="description">Versterk en verbeter je wifi-netwerk met meerdere zelflerende wifi-punten die strategisch op de zaak geplaatst worden.</p>
                          <a target="_blank" href="https://www.t-mobile.nl/zakelijk/internet/wifi-plus">Hoe werkt Wifi Plus?</a>
                        </div>
                      </div>
                    </div>
                    <div class="option-wrapper">
                      <div class="option">
                        <div class="icon-option">
                          <inline-svg width="42" height="42" class="indicator" :src="require(`@/assets/img/pin-veilig.svg`)"  alt="result-icon"/>
                        </div>
                        <div class="detail-option">
                          <p class="intro">PIN veilig</p>
                          <p class="description">Een betrouwbare pinverbinding voor je zaak. Zo kunnen je klanten zorgeloos pinnen, zelfs met topdrukte.</p>
                          <a target="_blank" href="https://www.t-mobile.nl/zakelijk/internet/pin-veilig?utm_source=keuzehulpzi&utm_medium=referral&utm_campaign=_zakelijk_map_tell_soho_fixed&utm_content=landingpagina_keuzehulp_zi_pinveilig">Hoe werkt PIN Veilig?</a>
                        </div>
                      </div>
                    </div>
                </div>
              </div>
          </div>
          <div class="col-md-4">
            <div class="side-item">
              <h3 class="header3">Liever een oplossing op maat?</h3>
              <p class="description">We helpen je graag met het vinden van het juiste zakelijk internet pakket. Laat je gegevens achter, dan nemen we zo snel mogelijk contact met je op. </p>
              <Button label="Laat gegevens achter" type="primary" size="desktop-inline" class="center-aligned" @click.native="nextPage" />
            </div>
            <div class="side-item">
              <div class="icon">
                <inline-svg width="48" height="48" class="indicator" :src="require(`@/assets/img/contact.svg`)"  alt="result-icon"/>
              </div>
              <h4 class="header4">Heb je vragen? Neem contact op</h4>
              <p class="times">Werkdagen: 8:00 - 20:00 uur <br>Zaterdag: 10:00 - 15:00 uur</p>
              <a href="tel:0800-0200739">0800 - 020 07 39</a>
            </div>
          </div>
          <div class="question-navigation">
            <div class="container p-0">
              <div class="button-set">
                <Button link="https://www.t-mobile.nl/zakelijk/shop/product/internet/zakelijk-internet-glasvezel?utm_source=keuzehulpzi&utm_medium=referral&utm_campaign=_zakelijk_map_tell_soho_fixed&utm_content=postcodecheck_keuzehulp_zi_postcodecheck" target="_blank" type="primary" label="DOE DE POSTCODECHECK" class="desktop-inline" />
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <div class="view form" v-if="currentView == 8">
      <div class="container">
        <div class="top-nav" :style="{display: 'flex', alignItems: 'center'}" >
          <div class="restart to-home" :style="{display: 'flex', alignItems: 'center', marginRight: '16px'}"  @click="restartPage()"><div class="icon-item" :style="{position: 'relative', top: '-2px'}"><inline-svg width="20" height="20" class="indicator" :src="require(`@/assets/img/next.svg`)" fill="var(--blue-dark)" :style="{transform: 'rotate(180deg)'}" alt="result-icon"/></div>Terug naar het begin</div>
          <div class="restart to-advice" :style="{display: 'flex', alignItems: 'center', marginRight: '16px'}"  v-if="!formRestart" @click="currentView = 7">
            <div class="icon-item" :style="{position: 'relative', top: '-2px'}">
              <inline-svg width="20" height="20" class="indicator" :src="require(`@/assets/img/next.svg`)" fill="var(--blue-dark)" :style="{transform: 'rotate(180deg)'}" alt="result-icon"/></div>
              Terug naar advies
          </div>
        </div>
        
        <h2 class="header2">Oplossing op maat</h2>
        <p class="description">
          Werken er meer dan twintig medewerkers in jouw bedrijf? Dan helpen we je graag aan Zakelijk Internet pakket op maat. Zo weet je zeker dat je een pakket kiest dat bij je bedrijf past. Laat je gegevens achter, dan nemen we zo snel mogelijk contact met je op.
        </p>
        <div class="holder-form">
          <form id="kennisform">
            <div class="group">
              <div class="label">Bedrijfsgegevens:</div>
              <div class="holder-group">
                <div class="row hide-mobile">
                  <div class="input-fix col-12 col-md-8">
                    <div class="input">
                      <input type="text" placeholder="Bedrijfsnaam" name="company_name"/>
                    </div>
                  </div>
                  
                  <div class="input-fix col-12 col-md-4">
                    <div class="input">
                      <select type="text" placeholder="Bedrijfs grootte" name="company_size">
                        <option value="" disabled selected>Grootte van bedrijf</option>
                        <option value="1">Zelfstandig</option>
                        <option value="2 - 5">2 - 5</option>
                        <option value="6 - 20">6 - 20</option>
                        <option value="21 - 249">21 - 249</option>
                        <option value="250 +">250+</option>
                      </select>
                    </div>
                  </div>
                </div>
                <div class="row">
                  <div class="input-fix col-12 col-md-4">
                    <div class="input">
                      <input type="text" placeholder="Postcode" name="zipcode"/>
                    </div>
                  </div>
                  <div class="input-fix col-12 col-md-4">
                    <div class="input">
                      <input type="text" placeholder="Huisnummer" name="house_number"/>
                    </div>
                  </div>
                  <div class="input-fix col-12 col-md-4">
                    <div class="input">
                      <input type="text" placeholder="Plaats" name="city"/>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            
            <div class="label">Jouw gegevens:</div>
            <div class="holder-group">
              <div class="row">
                <div class="input-fix col-12 col-md-6">
                  <div class="input" :class="!formData.firstName.value && formData.firstName.checked ? 'error' : ''" >
                    <input type="text" name="first_name" placeholder="Voornaam*" v-model="formData.firstName.value"/>
                    <inline-svg class="indicator" :src="require(`@/assets/img/check.svg`)" fill="var(--green)" v-if="formData.firstName.approved" alt="indicator-check"/>
                    <inline-svg class="indicator" :src="require(`@/assets/img/error.svg`)" v-if="!formData.firstName.value && formData.firstName.checked" alt="indicator-error"/>
                  </div>
                </div>
                <div class="input-fix col-12 col-md-6">
                  <div class="input" :class="!formData.lastName.value && formData.lastName.checked ? 'error' : ''" >
                    <input type="text" name="last_name" placeholder="Achternaam*" v-model="formData.lastName.value"/>
                    <inline-svg class="indicator" :src="require(`@/assets/img/check.svg`)" fill="var(--green)" v-if="formData.lastName.approved" alt="indicator-check"/>
                    <inline-svg class="indicator" :src="require(`@/assets/img/error.svg`)" v-if="!formData.lastName.value && formData.lastName.checked" alt="indicator-error"/>
                  </div>
                </div>
              </div>
            </div>
            <div class="input" :class="formData.phoneNumber.checked && !formData.phoneNumber.approved ? 'error' : ''" >
              <input type="text" name="phone_number" placeholder="Telefoonnummer* (06-XXX)" v-model="formData.phoneNumber.value"/>
              <inline-svg class="indicator" :src="require(`@/assets/img/check.svg`)" fill="var(--green)" v-if="formData.phoneNumber.approved" alt="indicator-check"/>
              <inline-svg class="indicator" :src="require(`@/assets/img/error.svg`)" v-if="formData.phoneNumber.checked && !formData.phoneNumber.approved" alt="indicator-error"/>
            </div>
            <div class="input" :class="formData.email.checked && !formData.email.approved ? 'error' : ''" >
              <input type="text" name="email" placeholder="E-mail*" v-model="formData.email.value"/>
              <inline-svg class="indicator" :src="require(`@/assets/img/check.svg`)" fill="var(--green)" v-if="formData.email.approved" alt="indicator-check"/>
              <inline-svg class="indicator" :src="require(`@/assets/img/error.svg`)" v-if="formData.email.checked && !formData.email.approved" alt="indicator-error"/>
            </div>
            <input type="hidden" name="elqFormName" value="internetkeuzehulp-tmobile-lw">
            <input type="hidden" name="elqSiteID" value="164251491">
            <div class="holder-checkbox">
              <input class="checkbox" type="checkbox" name="form_permission" id="newscheck">
              <label for="newscheck" v-bind:class="[{ 'active': checkboxActive }]" class="fake-checkbox" @click="setCheckbox()"><inline-svg width="15" height="15" :src="require(`@/assets/img/check.svg`)" v-if="checkboxActive" alt="checkbox-check"/></label>
              <div class="checkbox-description">We gebruiken deze gegevens alleen om contact met je op te nemen. Je vindt hier meer informatie over in ons privacy statement.</div>
            </div>
            <Button type="primary" size="desktop-inline" :class="[{'disabled': !formApproved}]" label="Verstuur" @click.native="getFormData"/>
          </form>
        </div>
      </div>
    </div>
    
    <div class="view" v-if="currentView == 9">
      <div class="container full full-centered">
          <div class="holder-content">
            <div class="check-icon"><inline-svg width="48" height="48" class="indicator" :src="require(`@/assets/img/check.svg`)" fill="var(--white)"  alt="result-icon"/></div>
            <h3 class="header3">Dankjewel!</h3>
            <p>We streven ernaar om binnen 2 werkdagen contact met je op te nemen. Ondertussen meer weten over ons Zakelijk Internet aanbod? </p>
            <Button class="m-top" target="_blank" type="primary" label="ONTDEK ZAKELIJK INTERNET" link="https://www.t-mobile.nl/zakelijk/internet?utm_source=keuzehulpzi&utm_medium=referral&utm_campaign=_zakelijk_map_tell_soho_fixed&utm_content=landingpagina_keuzehulp_zi_productpagina" />
          </div>
      </div>
    </div> 
  </div>
</template>

<script>
import axios from 'axios';
import Button from "@/components/Button.vue";
import Question from "@/components/Question.vue";
import QuestionSelect from "@/components/QuestionSelect.vue";
import Input from "@/components/Input.vue";
import InlineSvg from 'vue-inline-svg';
import VueSlickCarousel from 'vue-slick-carousel'
import 'vue-slick-carousel/dist/vue-slick-carousel.css'
import 'vue-slick-carousel/dist/vue-slick-carousel-theme.css'

export default {
  name: "Home",
  components: {
    InlineSvg,
    Button,
    Question,
    QuestionSelect,
    Input,
    VueSlickCarousel  
  },
  data() {
    return {
      currentView: 1,
      mobileView: false,
      answerLabel: '',
      slickSettings: {
        dots: true,
        dotsClass: "slick-dots custom-dot-class",
        infinite: false,
        speed: 500,
        slidesToShow: 1,
        slidesToScroll: 1,
        centerMode: true,
        centerPadding: '10%',
        prevArrow: null,
         nextArrow: null,
      },
      MySelectedValue: "",
      firstQuestion: "",
      firstApproved: false,
      secondQuestion: [{setting: false, value: 'basic,compleet,extra', name: 'Medewerkers'}, {setting: false, value: 'basic,compleet,extra', name: 'Bewoners'}, {setting: false, value: 'compleet,extra', name: 'Gasten'} ,{setting: false, value: 'compleet,extra', name: 'Klanten'}],
      secondApproved: false,
      thirdQuestion: "",
      thirdApproved: false,
      fourthQuestion: [{setting: false, value:'basic', name:'Internet + email'}, {setting: false, value:'extra', name: 'Cloudservices'}, {setting: false, value:'compleet', name: ' Videobellen'} ,{setting: false, value:'compleet', name: 'Downloaden'},{setting: false, value:'compleet', name: 'Gebruik buiten pand'},{setting: false, value:'extra',name: 'Pin transacties'},{setting: false, value:'maat', name: 'Geen opties (op maat)'}],
      fourthApproved: false,
      checkboxActive: false,
      resultData: {
        basic: {
          'name': 'Internet Basis',
          'detail': 'Glasvezel 50/50 Mbps',
          'discount': 'Eerste 6 maanden € 21,00 korting',
          'price': '21,00',
          'description': 'Met deze internetsnelheid kun je prima browsen en e-mailen. Heb je een klein kantoor met een paar medewerkers? En gebruiken jullie het internet niet allemaal tegelijkertijd en hoeven jullie niet constant het internet leeg te trekken met zware dingen, zoals grote bestanden downloaden en veel videobellen? Dan heb je meer dan genoeg aan dit pakket.',
          'list': ['Gratis <a target="_blank" href="https://www.t-mobile.nl/zakelijk/internet/back-up?utm_source=keuzehulpzi&utm_medium=referral&utm_campaign=_zakelijk_map_tell_soho_fixed&utm_content=landingpagina_keuzehulp_zi_internetbackup)">Internet Back-up</a>', 'Gratis installatie door onze monteurs', 'Meer dan 2.000 uur aan streaming via Netflix']
        },
        compleet: {
          'name': 'Internet Compleet',
          'detail': 'Glasvezel 100/100 Mbps',
          'discount': 'Eerste 6 maanden € 22,00 korting',
          'price': '22,00',
          'description': 'Deze internetsnelheid past goed bij een bedrijf met zwaarder internetgebruik. Bijvoorbeeld als in het bedrijf verschillende medewerkers tegelijkertijd online werken, veel videobellen en jullie gebruikmaken van een VPN of beveiligingsapparatuur.',
          'list': ['Gratis <a target="_blank" href="https://www.t-mobile.nl/zakelijk/internet/back-up?utm_source=keuzehulpzi&utm_medium=referral&utm_campaign=_zakelijk_map_tell_soho_fixed&utm_content=landingpagina_keuzehulp_zi_internetbackup)">Internet Back-up</a>', 'Gratis installatie door onze monteurs', 'Meer dan 2.000 uur aan streaming via Netflix']
        },
        extra: {
          'name': 'Internet Extra',
          'detail': 'Glasvezel 500/500 Mbps',
          'discount': 'Eerste 6 maanden € 25,50 korting',
          'price': '25,50',
          'description': 'Dit pakket past goed bij organisaties die actief internet gebruiken. Dat betekent dat in jouw bedrijf bijvoorbeeld meerdere medewerkers en/of klanten tegelijkertijd het internet gebruiken. Er wordt onder andere veel in de cloud gewerkt en er vinden vaak pintransacties plaats.',
          'list': ['Gratis <a target="_blank" href="https://www.t-mobile.nl/zakelijk/internet/back-up?utm_source=keuzehulpzi&utm_medium=referral&utm_campaign=_zakelijk_map_tell_soho_fixed&utm_content=landingpagina_keuzehulp_zi_internetbackup)">Internet Back-up</a>', 'Gratis installatie door onze monteurs', 'Meer dan 2.000 uur aan streaming via Netflix']
        },
        maat: {
          'name': 'Op maat pakket',
          'detail': 'Detail pakket',
          'discount': 'Pakket korting',
          'price': '--',
          'description': 'Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi',
          'list': ['Item 1', 'Een ander item', 'Goede prijs!']
        }
      },
      result: 'basic',
      formData: {
        firstName: {value: '', approved: false, checked: false},
        lastName: {value: '', approved: false, checked: false},
        phoneNumber: {value: '', approved: false, checked: false},
        email:  {value: '', approved: false, checked: false}
      },
      formDataCopy: {
        firstName: {value: '', approved: false, checked: false},
        lastName: {value: '', approved: false, checked: false},
        phoneNumber: {value: '', approved: false, checked: false},
        email:  {value: '', approved: false, checked: false}
      },
      formApproved: false,
      formRestart: false,
    }
  },
  methods: {
    isMobile() {
      if(window.innerWidth <= 768){return true} else {return false}
    },
    nextPage(){
      if(this.currentView == 4 && this.thirdQuestion == 'maat'){
        this.currentView = 8
        this.formRestart = true;
      } else if(this.currentView == 5 && this.fourthQuestion[6].setting){
        this.currentView = 8
      } else {
        this.currentView++
      }

      if(this.currentView == 6){
        this.calculateResult()
      }
    },
    calculateResult(){
      let result = {
        basic: 0,
        compleet: 0,
        extra: 0,
        maat: 0
      }
      //first question
      let answerOneSplit = this.firstQuestion.split('|')
      let answerOne =  answerOneSplit[1].split(',')
      let answerLabel = answerOneSplit[0];
      console.log(answerOneSplit, {answerLabel}, answerOne)
      for(let i = 0; i <  answerOne.length; i++){
        if(answerOne[i] !== 'diff'){
          result[answerOne[i]]++
        }
      }

      
      //second question
      for(let i = 0; i < this.secondQuestion.length; i++){
        if(this.secondQuestion[i].setting){
          let answer = this.secondQuestion[i].value.split(',')
          for(let x = 0; x <  answer.length; x++){result[answer[x]]++}
        }
      }

      //third question
      let answerThree = this.thirdQuestion.split(',')
      for(let i = 0; i <  answerThree.length; i++){result[answerThree[i]]++}

      //fourth question
      for(let i = 0; i < this.fourthQuestion.length; i++){
        if(this.fourthQuestion[i].setting){
          let answer = this.fourthQuestion[i].value.split(',')
          for(let x = 0; x <  answer.length; x++){
            if(answer == 'extra'){
              result[answer[x]] = result[answer[x]] + 10
            } else {
              result[answer[x]]++
            }
          }
        }
      }
      this.answerLabel = answerLabel
      if(answerLabel === 'koper'){
        result['extra'] = 0
      }

      console.log(result)
      //check higest
      let highest = 0
      let winner = ''
      if(result['basic'] > highest){highest = result['basic']; winner = 'basic'}
      if(result['compleet'] > highest){highest = result['compleet']; winner = 'compleet'}
      if(result['extra'] > highest){highest = result['extra']; winner = 'extra'}
      if(result['maat'] > highest){highest = result['maat']; winner = 'maat'}

      this.result = this.resultData[winner];


      console.log(this.result)
      setTimeout(
        () => {this.currentView++}
      , 3000)
    },
    setCheckbox(){
      this.checkboxActive = !this.checkboxActive
      if(this.formData.firstName.approved && this.formData.lastName.approved && this.formData.phoneNumber.approved && this.formData.email.approved && this.checkboxActive){
        this.formApproved = true;
      } else {
        this.formApproved = false;
      }
    },
    getFormData(){
      const form = document.getElementById('kennisform')
      const formData = new FormData(form);

      let allAnswers = JSON.stringify({firstQuestion: this.firstQuestion, secondQuestion: this.secondQuestion, thirdQuestion: this.thirdQuestion, fourthQuestion: this.fourthQuestion})
      console.log(allAnswers)
      formData.append('question_data', allAnswers)

      const values = [...formData.entries()];
      console.log(values)

      axios.post('https://s164251491.t.eloqua.com/e/f2', formData, {
        headers: {
          'Content-Type': 'multipart/form-data'
        }
      }).then(({data})=> {
        this.currentView++
      });
      
      
    },

    restartPage(){
      this.MySelectedValue = "",
      this.firstQuestion = "",
      this.firstApproved = false,
      this.secondQuestion = [{setting: false, value: 'basic,compleet,extra', name: 'Medewerkers'}, {setting: false, value: 'basic,compleet,extra', name: 'Bewoners'}, {setting: false, value: 'compleet,extra', name: 'Gasten'} ,{setting: false, value: 'compleet,extra', name: 'Klanten'}],
      this.secondApproved = false,
      this.thirdQuestion = "",
      this.thirdApproved = false,
      this.fourthQuestion = [{setting: false, value:'basic', name:'Internet + email'}, {setting: false, value:'extra', name: 'Cloudservices'}, {setting: false, value:'compleet', name: ' Videobellen'} ,{setting: false, value:'compleet', name: 'Downloaden'},{setting: false, value:'compleet', name: 'Gebruik buiten pand'},{setting: false, value:'extra',name: 'Pin transacties'},{setting: false, value:'maat', name: 'Geen opties (op maat)'}],
      this.fourthApproved = false,
      this.checkboxActive = false
      this.currentView = 1;
      this.formRestart = false
    }
  },
  created(){
    const width = window.innerWidth;
    if(width <= 768){
      this.mobileView = true;
    }

    
  },
  watch: {
    firstQuestion: function(newVal, oldVal){
      console.log(newVal)
      if(newVal.length > 0){this.firstApproved = true}
    },
    secondQuestion: {
      handler: function(newVal){
        let check = 0;
        for(let i = 0; i < newVal.length; i++){
          if(newVal[i].setting){
            check++;
          }
        }
        if(check > 0){
          this.secondApproved = true;
        } else {
          this.secondApproved = false;
        }
      },
      deep: true
    },
    thirdQuestion: function(newVal, oldVal){
      if(newVal.length > 0){this.thirdApproved = true}
    },
    fourthQuestion: {
      handler: function(newVal){
        let check = 0;
        for(let i = 0; i < newVal.length; i++){
          if(newVal[i].setting){check++;}
        }
        if(check > 0){
          this.fourthApproved = true;
        } else {
          this.fourthApproved = false;
        }
      },
      deep: true
    },

    formData: {
      handler: function(){
        //check first name
        let firstNameNew = this.formData.firstName.value;
        let firstNameOld = this.formDataCopy.firstName.value
        if(firstNameNew !== firstNameOld){
          this.formDataCopy.firstName.value = this.formData.firstName.value;
          this.formData.firstName.checked = true;
          if(this.formData.firstName.value.length > 0){
            this.formData.firstName.approved = true
          } else {
            this.formData.firstName.approved = false; 
            
          }
        }

        let lastNameNew = this.formData.lastName.value;
        let lastNameOld = this.formDataCopy.lastName.value
        if(lastNameNew !== lastNameOld){
          this.formDataCopy.lastName.value = this.formData.lastName.value;
          this.formData.lastName.checked = true;
          if(this.formData.lastName.value.length > 0){
            this.formData.lastName.approved = true
          } else {
            this.formData.lastName.approved = false; 
          }
        }

        let phoneNumberNew = this.formData.phoneNumber.value;
        let phoneNumberOld = this.formDataCopy.phoneNumber.value
        if(phoneNumberNew !== phoneNumberOld){
          this.formDataCopy.phoneNumber.value = this.formData.phoneNumber.value;
          this.formData.phoneNumber.checked = true;
          if(this.formData.phoneNumber.value.length > 0){
            var phoneno = /^\+?([0-9]{2})\)?[-. ]?([0-9]{4})[-. ]?([0-9]{4})$/;
            if(this.formData.phoneNumber.value.match(phoneno)) {
              this.formData.phoneNumber.approved = true
            }  else {
              this.formData.phoneNumber.approved = false
            }
          } else {
            this.formData.phoneNumber.approved = false; 
          }
        }

        let emailNew = this.formData.email.value;
        let emailOld = this.formDataCopy.email.value
        if(emailNew !== emailOld){
          this.formDataCopy.email.value = this.formData.email.value;
          this.formData.email.checked = true;
          if(this.formData.email.value.length > 0){
            var email = /^(([^<>()[\]\\.,;:\s@\"]+(\.[^<>()[\]\\.,;:\s@\"]+)*)|(\".+\"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/
            if(this.formData.email.value.match(email)) {
              this.formData.email.approved = true
            }  else {
              this.formData.email.approved = false
            }
          } else {
            this.formData.email.approved = false; 
          }
        }

        if(this.formData.firstName.approved && this.formData.lastName.approved && this.formData.phoneNumber.approved && this.formData.email.approved && this.checkboxActive){
          this.formApproved = true;
        } else {
          this.formApproved = false;
        }

      },
      deep: true
    }
  }
};
</script>

<style lang="scss">
.view{
  width: 100%;
  height: 100%;
  min-height: 100vh;
  position: relative;
  background-color: var(--white-ash);
  padding: 32px 0px;
  padding-bottom: 72px;
  &.bg-pink{
    background-color: var(--pink);
    .header1, .header2, .header3, .header4, p, .text-caption{
      color: var(--white);
    }
  }
  .header1{
    font-weight: 800;
  }
  .header1, p{
    margin-bottom: 12px;
  }
  .view-title{
    margin-bottom: 24px;
    p{
      margin-top: 8px;
      color: var(--blue-dark);
    }
    @include tablet-up{
      max-width: 588px;
      margin:0 auto 24px;
    }
  }
  .header2{
    font-weight: 700;
  }
  .container.centered{
    @include tablet-up{
      margin-top: 150px
    }
  }
  .container.full-centered{
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%,-50%);
    width: 100%;
    text-align: center;
    max-width: 348px;
    h3{
      font-weight: 800;
    }
    p{
      margin-top: 12px;
      margin-bottom: 0;
      text-align: left;
      &.text-white{
        color: white;
      }
      &.text-center{
        margin-top: 8px;
        text-align: center;
      }
    }
    .m-top{
      margin-top: 24px;
    }
  }
  .loader {
    border-radius: 50%;
    width: 48px;
    height: 48px;
    border: .25rem solid rgba(255,255,255,0.2);
    border-top-color: rgb(255,255,255);
    animation: spin 750ms infinite linear;
    margin: 0 auto;
    margin-bottom: 32px;
    &--double {
      border-style: double;
      border-width: .5rem;
    }

    @keyframes spin {
      0% {
        transform: rotate(0deg);
      }
      100% {
        transform: rotate(360deg);
      }
    }

    @keyframes pulse {	
      50% { 
        background: rgb(255,255,255);
      } 
    }
  }
  .check-icon{
    width: 64px;
    height: 64px;
    background-color: var(--green);
    border-radius: 100%;
    margin: 0 auto;
    margin-bottom: 32px;
    position :relative;
    svg{
      position: absolute;
      top: 50%;
      left: 50%;
      transform: translate(-50%,-50%);
    }
  }
}

.top-nav{
  @include tablet-down{
    justify-content: space-between;
  }
}
.restart{
  color: var(--blue-dark);
  font-size: 14px;
  cursor: pointer;
  padding: 16px 0px;
  &:hover{
    text-decoration: underline;
  }
  @include tablet-up{
    padding: 0;
    margin-bottom: 24px;
  }
}

//Result page
.view.result{
  @include tablet-down{
    padding: 0;
    padding-bottom: 64px;
  }
  .container{
    padding-left: 0;
    padding-right: 0;
    max-width: 1200px;
    @include tablet-down{
      .row{
        margin-left: 0;
        margin-right: 0;
        .col-12, .col-md-8{
          padding-left: 0;
          padding-right: 0;
        }
      }
    }
    
    .result-item{
      background-color: var(--white);
      .top-bar{
        background-color: var(--pink);
        padding: 12px 16px;
        position: relative;
        &:after{
          content: '';
          position: absolute;
          left: 50%;
          top: 100%;
          width: 0;
          height: 0;
          border-left: 8px solid transparent;
          border-right: 8px solid transparent;
          border-top: 8px solid var(--pink);;
          clear: both;
          transform: translate(-50%,0);
        }
        .header4{
          font-weight: 800;
          color: var(--white);
          text-align: center;
        }
        .restart{
          position: absolute;
          right: 16px;
          top: 50%;
          transform: translate(0,-50%);
          color: white;
        }
      }
      .holder{
        padding: 40px 16px;
        box-shadow: 0px 4px 8px rgba(0, 0, 0, 0.08);
        border-radius: 0px 0px 4px 4px;
        margin-bottom: 40px;
        @include tablet-up{
          border: 1px solid #E20074;
          margin-bottom: 32px;
          padding: 40px 32px;
          display: flex;
        }
        .icon{
          width: 64px;
          height: 64px;
          margin: 0 auto;
          margin-bottom: 24px;
          @include tablet-up{
            margin: 0;
            margin-bottom: 0;
            margin-right: 32px;
          }
        }
        .details{
          width: 100%;
          @include tablet-up{
            width: calc(100% - 96px);
          }
          .pack-wrapper{
            margin-bottom: 16px;
            padding-bottom: 16px;
            border-bottom: solid 1px var(--gray);
            @include tablet-up{
              margin-bottom: 20px;
            padding-bottom: 20px;
            }
          }
          .header3{
            font-weight: bold;
            margin-bottom: 12px;
          }
          .total-detail{
            display: flex;
            justify-content: space-between;
            width: 100%;
            margin-bottom: 4px;
            p{
              margin-bottom: 0;
            }
          }
          p.pack-discount{
            color: var(--green);
            margin: 0;
          }
        }
        .disclaimer{
          padding: 12px;
          border-radius: 4px;
          border: 1px solid #7CC9F2;
          background: rgba(124, 201, 242, 0.12);
          display: flex;
          align-items: center;
          margin-bottom: 16px;
          @include tablet-up{
            margin-bottom: 20px;
          }
          .icon-disclaimer{
            width: 20px;
            height: 20px;
            margin-right: 12px;
            position: relative;
            svg{
              position: absolute;
              top: 0;
            }
          }
          p{
            margin: 0;
            max-width: calc(100% - 32px);
          }
          @include tablet-up{
            padding: 14px 12px;
          }
        }
        p.description{
          margin-bottom: 16px;
          @include tablet-up{
            margin-bottom: 20px;
          }
        }
        .pack-list{
          p.title{
            font-weight: 800;
            margin-bottom: 8px;
          }
          .list-item{
            display: flex;
            align-items: center;
            margin-bottom: 8px;
            &:last-child{
              margin-bottom: 0;
            }
            .icon-item{
              width:14px;
              height: 14px;
              margin-right: 12px;
              position: relative;
              svg{
                position: absolute;
                top: 0;
                left: 0;
              }
            }
          }
        }
      }
    }
    .extra-panels{
      .header3{
        font-weight: 800;
        text-align: center;
        margin-bottom: 24px;
        @include tablet-up{
          text-align: left;
          font-size: 18px;
          line-height: 24px;
          margin-bottom: 16px;
        }
      }
      .holder-options{
        padding: 0px 16px;
        padding-bottom: 78px;
        @include tablet-up{
          padding: 0;
        }
        .slick-next, .slick-prev{
          display: none !important;
        }
        .slick-list{padding:0 20% 0 0 !important;}
        .slick-dots {
          bottom: -36px;
        }
        .slick-dots li{
          width: auto;
          height: auto;
        }
        .slick-dots li button{
           width: auto;
          height: auto;
        }
        .slick-dots li button:before{
          content: '';
          width: 8px;
          height: 8px;
          background-color: var(--gray);
          border-radius: 100%;
          opacity: 1;
        }
        .slick-dots li.slick-active button:before{
          opacity: 1;
          background-color: var(--pink);
        }
        .option-wrapper{
          padding-right: 16px;
          @include tablet-up{
            padding-right: 0;
          }
        }
        .option{
          padding: 32px 16px;
          background-color: var(--white);
          box-shadow: 0px 4px 8px rgba(0, 0, 0, 0.08);
          border-radius: 4px;
          text-align: center;
          width: 100%;
          @include tablet-up{
            padding: 32px;
            display: flex;
            align-items: flex-start;
            margin-bottom: 12px;
            text-align: left;
          }
          .icon-option{
            width: 42px;
            height: 42px;
            margin: 0 auto;
            margin-bottom: 20px;
            position: relative;
            svg{
              position: absolute;
              top: 0;
              left: 0;
            }
            @include tablet-up{
              margin-bottom: 0;
              margin-right: 32px;
            }
          }
          .detail-option{
            width: 100%;
            @include tablet-up{
              width: calc(100% - 74px);
              
            }
            p.intro{
              font-weight: 800;
              margin-bottom: 8px;
            }
            p.description{
              margin-bottom: 16px;
            }
            a{
              color: var(--blue-dark);
            }
          }
        }
      }
    }

    .side-item{
      padding: 40px 16px;
      background: #FFFFFF;
      box-shadow: 0px 4px 8px rgba(0, 0, 0, 0.08);
      border-radius: 4px;
      margin-bottom: 40px;
      .header3, .header4{
        font-weight: 800;
        text-align: center;
        margin-bottom: 8px;
      }
      p.description{
        margin-bottom: 24px;
      }
      p.times{
        text-align: center;
      }
      a{
        display:block;
        text-align: center;
      }
      @include tablet-up{
        padding: 32px;
        margin-bottom: 24px;
      }
      .icon{
        width: 48px;
        height: 48px;
        margin: 0 auto;
        position: relative;
        margin-bottom: 20px;
        svg{
          position: absolute;
          top: 0;
          left: 0;
        }
      }
    }
  }
}

//Form page
.view.form{
  background-color: var(--white);
  .container{
    max-width: 588px;
    margin: 0 auto;
    h2.header2{
      margin-bottom: 12px;
    }
    p.description{
      margin-bottom: 32px;
    }
    .holder-form{
      form{
        .row{
          margin-left: 0;
          margin-right: 0;
        }
        .label{
          margin-bottom: 8px;
        }
        .group{
          margin-bottom: 12px;
        }
        .input{
          margin-bottom: 8px;
          overflow: hidden;
        }
        select{
          -webkit-appearance: none;
          outline: none;
          border: none;
          width: 100%;
          padding: 12px 16px;
          color: var(--gray-dark);
        }
        .holder-group{
          .input-fix{
            padding: 0;
            @include tablet-up{
              
            padding-right: 16px;
            &:last-child{
              padding-right: 0;
            }
            }
            
          }
        }
        .holder-checkbox{
          display: flex;
          margin: 12px 0px 24px;
          .checkbox{
            position: absolute;
            opacity: 0;
            visibility: hidden;
          }
          .fake-checkbox{
            position: relative;
            cursor: pointer;
            width: 18px;
            height: 18px;
            border: solid 2px var(--gray);
            margin-right: 16px;
            svg{
              position: absolute;
              top: 0;
              left: 0;
            }
          }
          .checkbox-description{
            width: calc(100% - 34px);
            font-size: 12px;
            font-weight: 500;
            line-height: 18px;
          }
        }
      }
    }
  }
  .input{
    display: inline-block;
    border: solid 1px var(--gray);
    border-radius: 4px;
    width:100%;
    position: relative;
    svg{
      position: absolute;
      right: 8px;
      top: 50%;
      transform: translate(0,-50%);
    }
    &.error{
      border: solid 1px var(--red-error);
    }
  }
  input{
    -webkit-appearance: none;
    outline: none;
    border: none;
    width: 100%;
    padding: 12px 16px;
  }
}

.media-container{
  position: relative;
  width: 100%;
  .media{
    width: 100%;
    img{
      width:100%;
      object-fit:cover;
    }
  }
}

.landing-button{
  margin-bottom: 24px;
}

.questions-view{
  position: relative;
  height: 100%;
  width: 100%;
}
.question-navigation{
  background-color: var(--white);
  position: fixed;
  bottom: 0;
  left: 0;
  width: 100%;
  padding: 12px;
  z-index: 5;
  .indicator{
    width: 100%;
    height: 4px;
    position: absolute;
    top: -4px;
    left: 0;
    .bar{
      position: absolute;
      width: 100%;
      height: 100%;
      top: 0;
      left: 0;
      background-color: var(--gray);
      .fill{
        position: absolute;
        width: 40%;
        height: 100%;
        top: 0;
        left: 0;
        background-color: var(--blue);
        transition: width 0.4s;
      }
    }
  }
  .container{
    margin:0 auto;
  }
  .button-set{
    display: flex;
    justify-content: flex-end;
  }
}
</style>
